import { render, staticRenderFns } from "./frontendRoleUserList.vue?vue&type=template&id=44d2764e&scoped=true&"
import script from "./frontendRoleUserList.vue?vue&type=script&lang=js&"
export * from "./frontendRoleUserList.vue?vue&type=script&lang=js&"
import style0 from "./frontendRoleUserList.vue?vue&type=style&index=0&id=44d2764e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2764e",
  null
  
)

export default component.exports